import styled from 'styled-components';
import { commonStyles } from './commonStyles';
export var SquareIcon = styled.div.withConfig({
  displayName: "SquareIcon",
  componentId: "sc-1yomb90-0"
})(["", ";background-color:", ";color:", ";svg{position:absolute;top:50%;left:50%;width:", "px;height:", "px;transform:translate(-50%,-50%);}"], commonStyles, function (_ref) {
  var theme = _ref.theme;
  return theme.colors.uiLL;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.defaultIconColor;
}, function (_ref3) {
  var size = _ref3.size;
  return size - Math.round(size * 0.35);
}, function (_ref4) {
  var size = _ref4.size;
  return size - Math.round(size * 0.35);
});